import { getToken, setToken, setExpiresIn, removeToken, removeExpiresIn } from '@/utils/auth'
import interfaceAPI from "@/interfaceAPI/index";
import { isParamEmpty } from "@/filters/index"
import { login, loginPhone, getInfo, logout, refreshToken, redirectLogin } from "@/interfaceAPI/login/interfaceAPI"

const defaulData = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    certiFlg: '',
    companyId: '',
    phoneNumber: '',
    corporateName: '',
    currSubstation: '',
    dict: [],
    loginDialogStatus: false,
    userSourceType: ''
  }
}

const state = defaulData();

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_EXPIRES_IN: (state, time) => {
    state.expires_in = time
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PHONENUMBER: (state, phoneNumber) => {
    state.phoneNumber = phoneNumber
  },
  SET_CORPORATENAME: (state, corporateName) => {
    state.corporateName = corporateName
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_CERTI_FLG: (state, certiFlg) => {
    state.certiFlg = certiFlg
  },
  SET_COMPANY_ID: (state, companyId) => {
    state.companyId = companyId
  },
  setCurrSubstation: (state, data) => {
    state.currSubstation = data
  },
  setDict(state, data) {
    state.dict = data
  },
  setLoginDialogStatus(state, data) {
    state.loginDialogStatus = data
  },
  setUserSourceType(state, data) {
    state.userSourceType = data
  }
};

const actions = {
  login({ commit }, userInfo) {
    const { username, password, verificationCode, uuid, userType } = userInfo;
    return new Promise((resolve, reject) => {
      // interfaceAPI.loginPlatform({username: username.trim(), password: password, verificationCode: verificationCode.trim(), uuid: uuid, userType:userType }).then(async response => {
      //     const { data } = response.data;
      //     await interfaceAPI.getLastLoginTime(data.backUserDto.id).then(res => {
      //         setLastLoginTime(!isParamEmpty(res.data.data) ? res.data.data.createTime : '首次登录');
      //     });
      //     commit("SET_TOKEN", data.token);
      //     commit("SET_REFRESH_TOKEN", data.refreshToken);
      //     commit("SET_USER_NAME", data.backUserDto.username);
      //     commit("SET_USER_INFO", data.backUserDto);

      //     setToken(data.token);
      //     setRefreshToken(data.refreshToken);
      //     setUserName(data.backUserDto.username);
      //     setUserInfo(JSON.stringify(data.backUserDto));
      //     resolve();
      // }).catch(error => {
      //     reject(error);
      // });
      login(userInfo).then(res => {
        let data = res.data
        setToken(data.access_token)
        commit('SET_TOKEN', data.access_token)
        setExpiresIn(data.expires_in)
        commit('SET_EXPIRES_IN', data.expires_in)
        resolve()
      }).catch(error => {
        reject(error);
      });
    });
  },
  loginPhone({ commit }, userInfo) {
    const { username, password, verificationCode, uuid, userType } = userInfo;
    return new Promise((resolve, reject) => {
      loginPhone(userInfo).then(res => {
        let data = res.data
        setToken(data.access_token)
        commit('SET_TOKEN', data.access_token)
        setExpiresIn(data.expires_in)
        commit('SET_EXPIRES_IN', data.expires_in)
        resolve()
      }).catch(error => {
        reject(error);
      });
    });
  },
    // 第三方银行登录
    ThirdLogin ({ commit }, params) {
        return new Promise((resolve) => {
            setToken(params.token)
            commit('SET_TOKEN', params.token)
            resolve()
        })
    },
  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // interfaceAPI.getUserInfo().then(response => {
      //   setCompanyInfo(JSON.stringify(response.data.data));
      //   resolve();
      // }).catch(error => {
      //   reject(error);
      // });
      getInfo().then(res => {
        const user = res.user
        const avatar = user.avatar;
        if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
          commit('SET_ROLES', res.roles)
          commit('SET_PERMISSIONS', res.permissions)
        } else {
          commit('SET_ROLES', ['ROLE_DEFAULT'])
        }
        const comBaseInfo = res.comBaseinfo
        commit('SET_NAME', user.userName)
        commit('SET_PHONENUMBER', user.phonenumber)
        commit('SET_CORPORATENAME', comBaseInfo && comBaseInfo.corporateName)
        commit('SET_AVATAR', avatar)
        commit('SET_COMPANY_ID', user.companyId)
        commit('setUserSourceType', user.userSourceType)
        if (res.roles[0] === 'enterprise') {
          commit('SET_CERTI_FLG', comBaseInfo && comBaseInfo.certiFlg || '1')
        }
        console.log(res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    });
  },
  loginOut({ commit, state }) {
    return new Promise((resolve, reject) => {
      // interfaceAPI.loginOut().then(() => {
      //   removeToken(); // must remove  token  first
      //   removeRefreshToken();
      //   removeUserName();
      //   removeUserInfo();
      //   removeCompanyInfo();
      //   removeLastLoginTime();
      //   commit("RESET_STATE");
      //   resolve();
      // })
      //   .catch(error => {
      //     reject(error);
      //   });
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('setUserSourceType', '')
        commit('SET_CERTI_FLG', '')
        removeToken()
        removeExpiresIn()
        sessionStorage.clear()
        resolve()

      }).catch(error => {
        reject(error);
      });
    });
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      removeRefreshToken();
      removeUserName();
      removeUserInfo();
      removeCompanyInfo();
      removeLastLoginTime();
      commit("RESET_STATE");
      resolve();
    });
  },

  // 刷新token
  RefreshToken({ commit, state }) {
    return new Promise((resolve, reject) => {
      refreshToken(state.token).then(res => {
        let data = res.data
        setToken(data.access_token)
        commit('SET_TOKEN', data.access_token)
        setExpiresIn(data.expires_in)
        commit('SET_EXPIRES_IN', data.expires_in)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  //统一认证登陆
  RedirectLogin({ commit }, params) {
    return new Promise((resolve, reject) => {
      redirectLogin(params).then(res => {
        let data = res.data
        setToken(data.access_token)
        commit('SET_TOKEN', data.access_token)
        setExpiresIn(data.expires_in)
        commit('SET_EXPIRES_IN', data.expires_in)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js